import { requestRightPanelClose } from '@/lib/panels/right-panel-events'

type NavigateSpreadArgs = {
  spreadIndex: number
  maxSpreadIndex: number
  onSpreadIndexChange?: (index: number) => void
  onNavigate?: (direction: 'prev' | 'next') => void
}

/** Previous/next spread button: moves one spread when there is one to move to. */
export function handleNavigateSpread(
  dir: 'prev' | 'next',
  { spreadIndex, maxSpreadIndex, onSpreadIndexChange, onNavigate }: NavigateSpreadArgs
): void {
  const canNavigate = dir === 'prev' ? spreadIndex > 0 : spreadIndex < maxSpreadIndex

  if (!canNavigate) return

  onSpreadIndexChange?.(dir === 'prev' ? spreadIndex - 1 : spreadIndex + 1)
  onNavigate?.(dir)
  // Whatever right panel is open belongs to the spread being left (e.g. the Backgrounds panel's
  // on-canvas tint/remove toolbars), so moving to another spread closes it (WMPCM-11050 AC-6).
  // A no-op when no panel is open.
  requestRightPanelClose()
}
